import React, { Component } from 'react';
import { Grid, Box, withWidth /* , isWidthUp, withStyles */ } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import style from './styles.module.scss';
import styled, { createGlobalStyle } from 'styled-components';
import SideDrawer from "./../../../contactUs/SideDrawer";
import BoxButton from './../../../../../shared/components/BoxButton';
import { TTIcon, FBIcon, LIIcon } from './../../../../../shared/components/SocialIcons';
import IconButton from '@material-ui/core/IconButton';
import Chip from '@material-ui/core/Chip';
import { Link } from "react-router-dom";
import CopyToClipboard from './../../../../../shared/components/CopyToClipboard';
import { Radios } from 'mui-rff';
import { Form } from 'react-final-form'
import numeral from 'numeral'
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "redux/actions/auth";
import { NumberFieldStyled } from './../../Bag';
import getSymbolFromCurrency from 'currency-symbol-map';
import { convertToCurrency } from 'shared/functions/priceCalc';

const HideTrengoChat = createGlobalStyle`
#trengo-web-widget{
  display: none !important;
}
`;

const SubTotal = styled(props => <div {...props}>
    <div className="divider"></div>
Total
{props.price && <div className="price">{props.price.split('.')[0]}<small>.{props.price.split('.')[1]}</small></div> || ''}
    {!props.price && <div className="price">N/A</div> || ''}
</div>)`
  padding-left: 40px;
  padding-right: 40px;
  font-family: Lato;
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: left;
  color: #8d9298;
  padding-bottom: 21px;

  .divider{
    margin-bottom: 12px;
    border-top: solid 2px #d9dbe0;
  }

  .price{
        height: 13px;
        margin: 8.5px 0 0 0;
        font-family: Lato;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.93;
        letter-spacing: normal;
        text-align: left;
        color: #24272b;
    }
    .small {
        font-size: 11px;
    }
`;


class DiamondSideDrawer extends Component {

    state = {
        open: false,
        itemInBag: true,
    }

    componentDidMount() {
        this.setState({ open: this.props.open });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.open !== this.props.open) {
            this.setState({ open: this.props.open });
        }
    }

    closeBag = () => {
        this.setState({ open: false, itemInBag: true });
        this.props.closeBag();
    };

    removeStockFromBag(stock) {
        this.props.removeFromBag(stock);
        this.setState({ itemInBag: false })
    }

    updateItemField(fieldName, value, stock) {
        this.props.updateItemInBag(stock, fieldName, value);
    }

    getItemInBag(row, authUser) {
        const itemInBag = authUser.bag.find(i => row && i.stock._id === row._id);
        if (!itemInBag) return false;

        if (!itemInBag.selectedUnit) {
            itemInBag.selectedUnit = 'weight';
            itemInBag.weight = 0.01;
        }

        return itemInBag;
    }

    renderNumberField(row, authUser) {
        const itemInBag = this.getItemInBag(row, authUser);
        if (!itemInBag) return '';

        const selectedUnit = itemInBag.selectedUnit || 'weight';
        const value = itemInBag[selectedUnit]/*  ? itemInBag[selectedUnit] : selectedUnit === 'weight' ? 0.01 : 1 */;
        row = (itemInBag && itemInBag.stock) || {};
        const isParcel = row.StkCatType === 'Multiple Items';

        return isParcel && <div style={{ marginTop: 50 }}>
            <Form
                onSubmit={() => { }}
                initialValues={{
                    [selectedUnit]: value,
                }}
                render={() => <NumberFieldStyled name={selectedUnit} selectedUnit={selectedUnit} onChange={(value, itemType) => this.updateItemField(itemType, value, row._id)} />}
            />
        </div>
    }

    convertToCurrency(amount, isParcel) {
        const { ccy, fxrates = [] } = this.props;
        return convertToCurrency(amount, isParcel, fxrates, ccy);
    }

    render() {
        const { open, itemInBag } = this.state;
        let { row, authUser, ccy, fxrates = [], isLoading, width, isAuthorised } = this.props;
        const isParcel = row && row.StkCatType === 'Multiple Items' ? true : false;
        const specialOffer = row && row.WebSpecial ? true : false;
        const isMobile = width === 'xs';

        if(row){
            row = {
                ...row,
                priceOrig: row.price,
                ppcOrig: row.ppc,
                price: row.WebSpecial || row.price || row.ExWebTotal,
                ppc: row.WebSpecial || row.ppc || row.ExWebTotal,
                specialOffer: row.WebSpecial ? true : false,
            }
        }

        return (

            <SideDrawer
                style={{
                    maxHeight: open === 'download' ? '100%' : 755,
                    minWidth: open === 'download' && (!isMobile ? 270 : '100%'),
                    width: open === 'download' && (!isMobile ? 270 : '100%'),
                }}
                variant={open === 'download' && 'persistent'}
                title={<span style={{ display: 'flex', justifyContent: 'center' }}>
                    {open === 'bag' && <React.Fragment>YOUR BAG <Avatar style={{ marginLeft: 8, width: 18, height: 18, fontSize: 12, backgroundColor: '#b08f6e' }}>{(authUser && authUser.bag && authUser.bag.length) || 0}</Avatar></React.Fragment>}
                    {open === 'share' && <React.Fragment>SHARE</React.Fragment>}
                    {open === 'price' && <React.Fragment>PRICE</React.Fragment>}
                    {open === 'download' && <React.Fragment>DOWNLOAD</React.Fragment>}
                </span>}
                open={open ? true : false}
                boxButtonIcon="/images/next.svg"
                onClose={this.closeBag}
            >

                {['bag', 'share'].includes(open) &&
                    <div className={style.bagContents}>

                        {open === 'bag' && !itemInBag && <div>
                            <div className={style.center}>
                                <img alt="" src="/images/Screenshot 2020-11-18 at 10.32.36.jpg" />
                            </div>
                            <div className={style.center}>
                                <Link to="/diamonds/all">
                                    <Button type="button" variant="contained" color="secondary" >Go shop</Button>
                                </Link>
                            </div>
                        </div>}

                        <div className={style.bagContentsRow}>
                            {open === 'bag' && itemInBag && <div style={{ fontSize: 12, paddingTop: 6 }}>Stock code: {row.StkCodeCalcNS || '-'}</div>}

                            {(open === 'share' || (open === 'bag' && itemInBag)) && <div>
                                <div className={style.diamondThumbWrap}>
                                    <img alt="" src={row.img} />
                                </div>
                            </div>}

                            {open === 'bag' && itemInBag && <div>
                                <Button
                                    type="button"
                                    color="default"
                                    onClick={() =>
                                        this.removeStockFromBag(row._id)
                                    }
                                >
                                    REMOVE
                                </Button>
                            </div>}
                        </div>

                        {(open === 'share' || (open === 'bag' && itemInBag)) &&
                            <div className={style.bagItemDetails}>
                                <h3 className={specialOffer && style.specialOffer}>
                                    {isParcel && <div>{getSymbolFromCurrency(ccy) + numeral(Math.round(this.convertToCurrency(row.ppc, true))).format('0,0.00').split('.')[0]}<small>.{numeral(Math.round(this.convertToCurrency(row.ppc, true))).format('0,0.00').split('.')[1]}</small></div>}
                                    {!isParcel && <div>{getSymbolFromCurrency(ccy) + numeral(Math.round(this.convertToCurrency(row.price, false))).format('0,0.00').split('.')[0]}<small>.{numeral(Math.round(this.convertToCurrency(row.price, false))).format('0,0.00').split('.')[1]}</small></div>}
                                </h3>
                                <ul>
                                    {!isParcel && <React.Fragment>
                                        <li>{numeral(row.STWeight).format('0.00')}ct</li>
                                        <li>{row.colour || '-'}</li>
                                        <li>{row.clarity || '-'}</li>
                                    </React.Fragment>}
                                    {isParcel && <li>
                                        {[row.StkMes1, row.StkMes2, row.StkMes3].map(s => s && `${s}mm` || '-').join(' x ')}
                                    </li>}
                                </ul>
                            </div>
                        }

                        {row && open === 'bag' && this.renderNumberField(row, authUser)}

                        {open === 'share' &&
                            <Box mt={9} className={style.bagItemSocialShare}>
                                <Grid container justify="center" alignItems="center">
                                    <Grid item>
                                        <IconButton onClick={() => window.open(`https://facebook.com/sharer/sharer.php?u=${document.location.href}`, '_blank')}>
                                            <Chip label={<FBIcon />} className={style.rounded} />
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        <IconButton onClick={() => window.open(`https://twitter.com/intent/tweet/?text=${encodeURIComponent(isParcel ? `${row.StkShape} PARCEL` : `${numeral(row.STWeight).format('0.00')} CT ${row.StkShape} DIAMOND`)}&amp;url=${document.location.href}`, '_blank')}>
                                            <Chip label={<TTIcon />} />
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        <IconButton onClick={() => window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${document.location.href}`, '_blank')}>
                                            <Chip label={<LIIcon />} className={style.squared} />
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        <CopyToClipboard TooltipProps={{ title: "Copied to clipboard!", leaveDelay: 3000 }}>
                                            {({ copy }) => (
                                                <IconButton onClick={() => copy(document.location.href)}>
                                                    <Chip label={<img alt="" width="23" src="/images/share-icon.svg" />} />
                                                </IconButton>
                                            )}
                                        </CopyToClipboard>
                                    </Grid>
                                </Grid>
                            </Box>
                        }
                    </div>
                }

                {open === 'price' && <div className={style.bagContentsRowText}>

                    <table>
                        <tr>
                            {isAuthorised && isParcel && <td><b>PPC:</b> {row.ppcOrig ? <React.Fragment>{getSymbolFromCurrency(ccy)}{numeral(Math.round(this.convertToCurrency(row.ppcOrig, true, fxrates, ccy))).format('0,0.00')}</React.Fragment> : '-'}</td>}
                            {isAuthorised && !isParcel && <td><b>PPC:</b> {row.ppcOrig ? <React.Fragment>{getSymbolFromCurrency(ccy)}{numeral(Math.round(this.convertToCurrency(row.priceOrig, false, fxrates, ccy)) / parseFloat(row.STWeight)).format('0,0.00')}</React.Fragment> : '-'}</td>}
                        </tr>

                        {isAuthorised && !isParcel && <tr><td><b>RAP Below:</b> {row.RAP ? row.RAP + '%' : '-'}</td></tr>}

                        <tr>
                            {isAuthorised && !isParcel && <td><b>Price: </b> {getSymbolFromCurrency(ccy)}{numeral(Math.round(this.convertToCurrency(row.priceOrig, false, fxrates, ccy))).format('0,0.00')}</td>}
                        </tr>
                        <tr>
                            {isAuthorised && !isParcel && row.WebSpecial ? <td><b>Special Price:</b> {getSymbolFromCurrency(ccy)}{numeral(Math.round(this.convertToCurrency(row.price, false, fxrates, ccy))).format('0,0.00')}</td> : ''}
                            {isAuthorised && isParcel && row.WebSpecial ? <td><b>Special Price:</b> {getSymbolFromCurrency(ccy)}{numeral(Math.round(this.convertToCurrency(row.WebSpecial, true, fxrates, ccy))).format('0,0.00')}</td> : ''}
                        </tr>
                    </table>

                </div>}

                {open === 'bag' &&
                    <div style={{ position: 'absolute', bottom: 0, left: 0 }}>

                        {itemInBag && !isParcel && <SubTotal price={row.price ? getSymbolFromCurrency(ccy) + numeral(Math.round(this.convertToCurrency(row.price, false))).format('0,0.00') : 0} />}
                        {itemInBag && isParcel && <SubTotal price={this.getItemInBag(row, authUser).selectedUnit === 'weight' ? getSymbolFromCurrency(ccy) + numeral(Math.round(this.convertToCurrency(row.ppc, true)) * this.getItemInBag(row, authUser).weight).format('0,0.00') : 0} />}

                        <Link to="/diamonds/bag" style={{ textDecoration: 'none' }}>
                            <BoxButton
                                onClick={this.closeBag}
                                text={'VIEW BAG'}
                                iconPath="/images/next.svg"
                            />
                        </Link>
                    </div>
                }


                {open === 'download' && <div className={style.bagContentsRowText}>
                    <HideTrengoChat />
                    <Form
                        onSubmit={data => this.props.onSubmit(data, open)}
                        render={({
                            handleSubmit,
                            pristine,
                            form,
                            submitting,
                            values,
                        }) => {
                            return (
                                <form onSubmit={handleSubmit}>
                                    <p>
                                        Please select what you want to download
                                    </p>

                                    <div className={style.radiosWrap}>
                                        <Radios
                                            name="downloadType"
                                            required={true}
                                            data={[
                                                { label: 'Current filtered', value: 'current' },
                                                !isMobile ? { label: 'Only Ticked Items', value: 'selected' } : null,
                                                { label: 'All Certified Round', value: 'certified-rounds' },
                                                { label: 'All Certified Fancies', value: 'certified-fancies' },
                                                { label: 'All Certified', value: 'certified-all' },
                                                { label: 'All Parcels', value: 'parcels' },
                                            ].filter(a => a)}
                                        />
                                    </div>


                                    <p>
                                        Please select format
                                    </p>
                                    <div className={style.radiosWrap}>
                                        <Radios
                                            name="downloadFormat"
                                            required={true}
                                            data={[
                                                { label: 'Excel Sheet', value: 'excel' },
                                                { label: 'PDF', value: 'pdf' },
                                            ]}
                                        />
                                    </div>

                                    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
                                        <BoxButton
                                            style={{ width: "100%" }}
                                            disabled={!(values && values.downloadType && values.downloadFormat) || isLoading}
                                            text={isLoading ? 'PLEASE WAIT...' : 'DOWNLOAD'}
                                            iconPath="/images/download.svg"
                                        />
                                    </div>
                                </form>
                            )
                        }}
                    />
                </div>}


            </SideDrawer>
        )
    }
}

export default connect(
    state => ({
        isAuthorised: state.auth.isAuthorised,
        authUser: state.auth.user,
        ccy: state.site.ccy,
        fxrates: state.site.fxrates,
    }),
    (dispatch) => bindActionCreators({ ...AuthActions }, dispatch)
)(withWidth()(DiamondSideDrawer));